const doc = [({"ko":({"adminComponentCompanyPayment":({"companyPaymentIndexTitle":"지불 목록", "companyPaymentSummaryIndexTitle":"지불 개요", "showTargetBooking":"대상 예약 보기"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;